import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconAdClose = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...omit(props, ["className"])}
    ref={ref}
    className="yfm-icon yfm-icon-ad-close"
  >
    <circle cx="8" cy="8" r="8" fill="#5DE5E3" />
    <path
      d="M11.6137 10.9572L5.04368 4.38656C4.86181 4.20531 4.56743 4.20531 4.38618 4.38656C4.20493 4.56781 4.20493 4.86219 4.38618 5.04406L10.9562 11.6141C11.1381 11.7953 11.4324 11.7953 11.6137 11.6141C11.7949 11.4328 11.7949 11.1384 11.6137 10.9572Z"
      fill="#17215C"
    />
    <path
      d="M11.6137 4.38656C11.4324 4.20531 11.1381 4.20531 10.9562 4.38656L4.38618 10.9572C4.20493 11.1391 4.20493 11.4328 4.38618 11.6141C4.56743 11.7953 4.86181 11.7953 5.04368 11.6141L11.6137 5.04406C11.7949 4.86219 11.7949 4.56781 11.6137 4.38656Z"
      fill="#17215C"
    />
  </svg>
));

IconAdClose.displayName = "IconAdClose";

export default IconAdClose;
